import { IconComponent } from './types';

const SoilIcon: IconComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={9}
    viewBox="0 0 11 9"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M.625 6.667h2.708V5.584H.625v1.083Zm3.52 0h2.71V5.584h-2.71v1.083Zm3.522 0h2.708V5.584H7.667v1.083ZM.625 8.834h1.083V7.75H.625v1.084Zm2.167 0h1.083V7.75H2.792v1.084Zm2.166 0h1.084V7.75H4.958v1.084Zm2.167 0h1.083V7.75H7.125v1.084Zm2.167 0h1.083V7.75H9.292v1.084ZM.625 4.5h4.333V3.417H.625V4.5Zm5.417 0h4.333V3.417H6.042V4.5ZM.625.167v2.167h9.75V.167H.625Z"
    />
  </svg>
);
export default SoilIcon;
